// CST207: i18next configuration + init.
// Per plan: deterministic boot (useSuspense:false), returnNull:false, detector
// order localStorage → navigator, html[lang] sync via event.
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { NAMESPACES } from "./namespaces";
import { resources } from "./resources";

export const DEFAULT_LNG = "de" as const;
export const SUPPORTED_LNGS = ["de", "en"] as const;

export async function initI18n(): Promise<typeof i18n> {
  if (i18n.isInitialized) return i18n;

  await i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources,
      fallbackLng: DEFAULT_LNG,
      supportedLngs: [...SUPPORTED_LNGS],
      ns: [...NAMESPACES],
      defaultNS: "common",
      // Normalize region-tagged detections (e.g. en-US → en, de-DE → de) so
      // they match supportedLngs without needing explicit "en-US" entries.
      load: "languageOnly",
      nonExplicitSupportedLngs: true,
      returnNull: false, // never render "null" — CRITICAL per plan
      saveMissing: false,
      interpolation: { escapeValue: false }, // React auto-escapes
      detection: {
        order: ["localStorage", "navigator"],
        caches: ["localStorage"],
        lookupLocalStorage: "i18nextLng",
      },
      react: { useSuspense: false }, // pre-init, deterministic boot
    });

  // Keep <html lang> in sync with i18n language (initial + subsequent changes).
  if (typeof document !== "undefined") {
    document.documentElement.lang = i18n.language || DEFAULT_LNG;
  }
  i18n.on("languageChanged", (lng) => {
    if (typeof document !== "undefined") {
      document.documentElement.lang = lng;
    }
  });

  return i18n;
}

export { i18n };
